export const MAX_INT_SIZE = 2147483647
export const MIN_INT_SIZE = -2147483648
export const MAX_BIGINT_SIZE = 9223372036854775807
export const MIN_BIGINT_SIZE = -9223372036854775808
export const MAX_DECIMAL_8 = 999_999_999_999.99
export const MIN_DECIMAL_8 = -999_999_999_999.99
export const MAX_DECIMAL_9 = 9_999_999_999_999.9
export const MAX_DECIMAL_12 = 999_999_999_999.99
